import type { ReactElement, ReactNode } from "react";

import RedesignLayout from "@/chrome/RedesignLayout";
import JsonLdManager from "@/components/JsonLdManager/JsonLdManager";
import MaticPageMeta from "@/components/PageMetaManager/MaticPageMeta";
import HsaFsaView from "@/views/hsa-fsa/HsaFsaView";

const BREADCRUMBS = [
  { position: 1, name: "Home", item: "https://maticrobots.com" },
  {
    position: 2,
    name: "HSA/FSA",
    item: "https://maticrobots.com/hsa-fsa",
  },
] as const;

export default function HsaFsa() {
  return (
    <>
      <MaticPageMeta
        page="hsa-fsa"
        overrideTitle="Pay with HSA/FSA"
        overrideDescription="Qualifying customers can use HSA or FSA funds on Matic through Flex. See what qualifies and how to pay."
      />
      <JsonLdManager breadcrumbs={BREADCRUMBS} />
      <HsaFsaView />
    </>
  );
}

HsaFsa.getLayout = (page: ReactElement): ReactNode => (
  <RedesignLayout>{page}</RedesignLayout>
);
